/*
* store.js
*
* Description: Holds common/global Stores.
*
* This file is part of: "http://apps.sundair.com/", "SunCrew2 - Crewplanning"
* Copyright 2018,2019,2020 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Christian Arp <christian.arp@sundair.com>
* @author Learek <michael.broeker@sundair.com>
* @author Phillip Alsleben <phillip.alsleben@sundair.com>
*
*/
import Vue from 'vue';
import Vuex from 'vuex';
import crewplanning from './modules/crewplanning/crewplanning'; // 'Store::Crewplanning'
import crews from './modules/crewplanning/crews'; // 'Store::Crews'

import flights from './modules/flights/flights'; // 'Store::Flights'
import shared from './modules/shared/shared'; // 'Store::Shared'

import * as getters from './getters'; // global ones
import * as mutations from './mutations';
import * as actions from './actions';

Vue.use(Vuex);


export const store = new Vuex.Store({
    state: {
        value: 0 // >>> just demo
    },
    getters,
    mutations,
    actions,
    modules: {
        crewplanning,
        crews,
        flights,
        shared
    }
});
